export default {
  images: {
    avatar: {
      // default: 'taras.jpg',
      default: 'photo.jpg',
    },
    firstSlideImage: {
      // xs: 'IMG_6746-3-xs.webp',
      // sm: 'IMG_6746-3-xs.webp',
      // lg: 'slide1_x2.webp',
      xl: 'slide1_x2.webp',
      default: 'slide1.webp',
    },
    formSlideImage: {
      xl: 'slide3_x2.webp',
      default: 'slide3.webp',
    },
  },
};



// WEBPACK FOOTER //
// ./src/config.js